import { render, staticRenderFns } from "./SkillDetailPage.vue?vue&type=template&id=2c97cc2b&scoped=true&"
import script from "./SkillDetailPage.vue?vue&type=script&lang=js&"
export * from "./SkillDetailPage.vue?vue&type=script&lang=js&"
import style0 from "./SkillDetailPage.vue?vue&type=style&index=0&id=2c97cc2b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c97cc2b",
  null
  
)

export default component.exports